/**
 * Zod schemas for /api/search/category-tags -- the tag pills on the browse
 * pages: tags with enough browsable listings in one category group.
 */
import { z } from 'zod';

export const CategoryTagsRequestSchema = z.object({
  groupId: z.coerce.number().int().positive(),
});

export type CategoryTagsRequest = z.infer<typeof CategoryTagsRequestSchema>;

export const TagPillSchema = z.object({
  tag: z.string(),
  /** How the pill reads (utils/tag-label.ts): capitalised, humanized, product types plural. */
  label: z.string().optional(),
  count: z.number().int().nonnegative(),
  href: z.string(),
});

export type TagPill = z.infer<typeof TagPillSchema>;

export const CategoryTagsSuccessResponseSchema = z.object({
  success: z.literal(true),
  groupId: z.number().int(),
  pills: z.array(TagPillSchema),
});

export type CategoryTagsSuccessResponse = z.infer<typeof CategoryTagsSuccessResponseSchema>;

export const CategoryTagsErrorResponseSchema = z.object({
  success: z.literal(false),
  error: z.string(),
});

export type CategoryTagsErrorResponse = z.infer<typeof CategoryTagsErrorResponseSchema>;

export const CategoryTagsResponseSchema = z.discriminatedUnion('success', [
  CategoryTagsSuccessResponseSchema,
  CategoryTagsErrorResponseSchema,
]);

export type CategoryTagsResponse = z.infer<typeof CategoryTagsResponseSchema>;
